module.exports = "/_next/static/images/U-0220f0e18220dc396649626189b86f4f.png";